import BaseService from '../../services/Base/BaseServices'

let Base = new BaseService('LearningSteps');
const LearningStepsServices = Base.services;

export default LearningStepsServices;